import { TKeyValueDataString } from "../../../models/objects/gen";
import { TAnimationConfig } from "../../../models/objects/sprite";


export interface PhaserConfig {
  workspace: string;

  // Configuration de la scène
  scene: SceneConfig;

  // Liste des personnages
  characters: CharacterConfig[];

  // Liste des objets
  objects: ObjectConfig[];

  // Liste des textes
  texts: TextObjectConfig[];

  // Condition(s) de victoire
  winConditions: WinCondition[];

  // Liste des sons
  sounds: SoundConfig[];

  assets?: TKeyValueDataString[]
}

export interface SceneConfig {
  id: string;
  width: number;
  height: number;
  background: {
    image: string;
    mode: "cover" | "repeat";
  };
}

export interface CharacterConfig {
  id: string;
  idPhaser: string;
  name: string;
  x: number; // Position X (en px)
  y: number; // Position Y (en px)
  width: number;
  height: number;
  image_url: string;
  animations: TAnimationConfig[];
}

interface ObjectAssets {
  texture: string; // chemin ou key pour l’affichage
}

export interface ObjectConfig {
  id: string;
  idPhaser: string;
  name: string;
  x: number;
  y: number;
  width: number;
  height: number;
  immovable?: boolean;
  pickable?: boolean;
  pickOrder: number;
  pushable?: boolean;
  decor?: boolean;
  assets: ObjectAssets;
}

export interface TextObjectConfig {
  id: string;
  x: number;
  y: number;

  /**
   * Le texte initial à afficher
   */
  textString: string;

  /**
   * Style texte (couleur, background, taille de police, etc.)
   */
  fontFamily: string;
  fontSize?: number; // ex. 16
  color?: string; // ex. "#ffffff"
  backgroundColor?: string; // ex. "#00000088"
}

export interface WinCondition {
  id: string;
  // Ex : "characterCollision" | "characterAtPosition" | "objectDestroyed" etc.
  type: string;
  // Ensuite tu peux affiner selon le type de condition
  targetCharacterId?: string;
  targetObjectId?: string;
  targetPosition?: { x: number; y: number };
  specificPhrase?: string; // Nouveau champ pour la phrase spécifique
  targetTextObjectId?: string;

  /**
   * Valeur attendue du texte
   */
  expectedTextContent?: string;

  expectedTextBackgroundColor?: string;
}
export interface SoundConfig {
  id: string; // Identifiant unique côté front
  name: string; // Nom affiché (sera aussi utilisé comme clé pour l’asset audio)
  file_path: string; // Chemin ou URL de l’asset audio
  volume?: number; // Volume (entre 0.0 et 1.0)
  loop?: boolean; // Si le son doit être bouclé (true) ou non (false)
}


export function getDefaultConfigPhaser(
  width: number = 400,
  height: number = 400
): PhaserConfig {
  return {
    workspace: "",
    scene: {
      id: "",
      width: width,
      height: height,
      background: {
        image: "",
        mode: "cover",
      },
    },
    characters: [],
    objects: [],
    texts: [],
    winConditions: [],
    sounds: [],
  };
}
